import { isInternalStoryTraceLabel } from '@terra/ui-design-system';

export function generateExecutionTabTitle({
  executionTitle,
  fallback,
}: {
  executionTitle: string | undefined;
  fallback: string;
}): string {
  const trimmed = executionTitle?.trim();

  if (!trimmed || isInternalStoryTraceLabel(trimmed)) {
    return fallback;
  }

  return `Execution: ${trimmed}`;
}
